<template>
  <EditorView>
    <EditorToolbar>
      <template slot="elements">
        <div>
            <h4 class="wf-text-blue-700 wf-text-sm wf-lowercase wf-font-bold">
              <i class="fas wf-text-sm fa-clone wf-mr-2"></i>
              <span>Elements</span>
            </h4>
            <div class="wf-border-blue-700 wf-w-8 wf-border-2"></div>
            <div class="wf-mt-5">
              <SectionsSettings/>
            </div>
            <div class="wf-mt-5">
              <ComponentsSettings/>
            </div>
          </div>
      </template>
    </EditorToolbar>
    <EditorPageDevice>
      <EditorPageContent />
    </EditorPageDevice>
    <EditorIconModal />
    <EditorImagesModal />
    <EditorInputModal />
    <EditorComponentsModal />
    <EditorPreviewModeButton />
    <div
      v-if="$store.state.editingElement && ! previewMode"
      id="elementToolbar"
      class="wf-absolute wf-top-0 wf-right-0"
      style="width: 320px" :style="elementMenuOpen ? '' : 'margin-right:-248px'"
    >
      <ElementToolbar/>
    </div>
    <!-- <store-section-modal></store-section-modal> -->
  </EditorView>
</template>

<script>
  import SectionsSettings from '@/components/Settings/SectionsSettings'
  import ComponentsSettings from '@/components/Settings/ComponentsSettings'
  import EditorView from '@/components/EditorView'
  import EditorComponentsModal from '@/components/EditorComponentsModal'
  import EditorIconModal from '@/components/EditorIconModal'
  import EditorInputModal from '@/components/EditorInputModal'
  import EditorImagesModal from '@/components/EditorImagesModal'
  import EditorPageContent from '@/components/EditorPageContent'
  import EditorPageDevice from '@/components/EditorPageDevice'
  import EditorPreviewModeButton from '@/components/EditorPreviewModeButton'
  import ElementToolbar from '@/components/ElementToolbar'
  import EditorToolbar from '@/components/EditorToolbar'
  export default {
    components: {
      ComponentsSettings,
      SectionsSettings,
      EditorView,
      ElementToolbar,
      EditorComponentsModal,
      EditorIconModal,
      EditorInputModal,
      EditorImagesModal,
      EditorPreviewModeButton,
      EditorPageContent,
      EditorPageDevice,
      EditorToolbar
    },
    computed: {
      previewMode() {
        return this.$store.state.previewMode
      },
      elementMenuOpen() {
        return this.$store.state.elementToolbar
      },
    }
  }
</script>
